module.exports = __webpack_public_path__ + "static/apple-icon-152x152.ad683557.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon/apple-icon-152x152.png
// module id = 547
// module chunks = 168707334958949